var render, staticRenderFns
import script from "./CCard.vue?vue&type=script&lang=ts"
export * from "./CCard.vue?vue&type=script&lang=ts"
import style0 from "./CCard.vue?vue&type=style&index=0&id=4ff74da4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports